import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const BoxStyled = styled(Box, {
  borderRadius: '$3',
  height: '$3',
  marginRight: '$2',
  width: '$3',
});
